<script>
import {mapFields} from "vuex-map-fields";

export default {
  name: "EmailConfirmationReminder",
  data: () => ({
    isWaitingForCode: false,
    code: null
  }),
  methods: {
    checkCode() {
      this.$store.dispatch("auth/checkEmailConfirmationCode", {
        code: this.code,
      })
    },
    sendConfirmation() {
      this.$store.dispatch("auth/sendEmailConfirmationCode").then(() => {

      });
      this.isWaitingForCode = true
    }
  },
  computed: {
    ...mapFields("auth", [
      "isSendingEmailConfirmationCode",
      "isSentEmailConfirmationCode",
      "isCheckingEmailConfirmationCode",
      "isCheckedSuccessfullyConfirmationCode",
      "is_email_confirmed"
    ]),
  }
}
</script>

<template>
  <div>
    <v-alert
        v-model="isCheckedSuccessfullyConfirmationCode"
        border="left"
        close-text="Close Alert"
        color="success"
        dark
        dismissible
    >
      {{ $t('form.confirmation.success_title') }}
    </v-alert>
    <v-card
        color="#de7676"
        dark
        class="mb-4 mt-4"
        v-if="!isCheckedSuccessfullyConfirmationCode && !is_email_confirmed"
    >
      <div class="d-flex flex-no-wrap justify-space-between">
        <div>
          <v-card-title
              class="text-h5"
          >{{ $t('form.confirmation.title') }}
          </v-card-title>

          <v-card-subtitle>
            <div class="d-flex my-4 align-center" style="width: 220px" v-if="isWaitingForCode">
              <v-text-field
                  dense
                  hide-details
                  outlined
                  v-model="code"
                  :disabled="isSendingEmailConfirmationCode || isCheckingEmailConfirmationCode"
                  :label="$t('form.confirmation.code_label')"
              />
              <v-btn @click="checkCode" class="ml-1" color="success"
                     :disabled="isSendingEmailConfirmationCode || isCheckingEmailConfirmationCode">OK
              </v-btn>
            </div>
            <v-btn @click="sendConfirmation" small color="primary"
                   :loading="isSendingEmailConfirmationCode || isCheckingEmailConfirmationCode"
                   :disabled="isSendingEmailConfirmationCode || isCheckingEmailConfirmationCode">
              {{ isWaitingForCode ? $t('form.confirmation.resend_code') : $t('form.confirmation.send_code') }}
            </v-btn>
          </v-card-subtitle>


        </div>

        <v-avatar
            class="ma-3"
            size="60"
            tile
        >
          <v-icon>mdi-alert</v-icon>
        </v-avatar>
      </div>
    </v-card>
  </div>
</template>

<style scoped>

</style>